const ANY_OPTION_VALUE = "__any__";

export function hasFoilPrinting(printings) {
  return Array.isArray(printings) && printings.some((printing) => Boolean(printing?.foil));
}

export function hasNonfoilPrinting(printings) {
  return Array.isArray(printings) && printings.some((printing) => Boolean(printing?.nonfoil));
}

export function isFoilOnlyPrinting(printing) {
  return Boolean(printing?.foil) && !Boolean(printing?.nonfoil);
}

export function canChooseFoilOption({ selectedPrinting, printings, anyEdition = false, fallbackFoil = false } = {}) {
  if (anyEdition) {
    return hasFoilPrinting(printings);
  }

  if (selectedPrinting) {
    return Boolean(selectedPrinting.foil);
  }

  return Boolean(fallbackFoil);
}

export function shouldLockFoilSelection({ selectedPrinting, printings, anyEdition = false } = {}) {
  if (anyEdition) {
    return hasFoilPrinting(printings) && !hasNonfoilPrinting(printings);
  }

  return isFoilOnlyPrinting(selectedPrinting);
}

export function normalizeFoilSelection({ foil = false, anyFoil = false } = {}, context = {}) {
  if (shouldLockFoilSelection(context)) {
    return {
      foil: true,
      anyFoil: false
    };
  }

  return {
    foil: Boolean(foil),
    anyFoil: Boolean(anyFoil)
  };
}

export function isFoilOptionDisabled(optionValue, context = {}) {
  if (!shouldLockFoilSelection(context)) {
    return false;
  }

  return optionValue === "false" || optionValue === ANY_OPTION_VALUE;
}